import
{
    GoogleAuthProvider,
    signInWithPopup,
    signOut,
    onAuthStateChanged,
    signInAnonymously
} from "firebase/auth";
import { auth } from "./firebase.js";

const provider = new GoogleAuthProvider();

async function signInWithGoogle()
{
    try
    {
        const result = await signInWithPopup(auth, provider);
        return result.user;
    } catch (error)
    {
        console.error("Error signing in with Google:", error);
        return null;
    }
}

async function signOutUser()
{
    try
    {
        await signOut(auth);
    } catch (error)
    {
        console.error("Error signing out:", error);
    }
}

function onAuthStateChangedWrapper(callback)
{
    return onAuthStateChanged(auth, callback);
}

async function signInAnonymouslyUser()
{
    try
    {
        const result = await signInAnonymously(auth);
        return result.user;
    } catch (error)
    {
        console.error("Error signing in anonymously:", error);
        return null;
    }
}

async function getIdToken() {
    const user = auth.currentUser;
    if (!user) {
        return null;
    }
    return await user.getIdToken();
}

export
{
    signInWithGoogle,
    signOutUser,
    onAuthStateChangedWrapper as onAuthStateChanged,
    signInAnonymouslyUser,
    ensureSignIn,
    getIdToken
};

function ensureSignIn(anonymousOk = false)
{
    return new Promise((resolve) =>
    {
        const unsubscribe = onAuthStateChanged(auth, (user) =>
        {
            unsubscribe();
            if (user)
            {
                resolve(user);
            } 
            else
            {
                if (anonymousOk) {
                    signInAnonymouslyUser().then(resolve);
                } else {
                    window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
                }
            }
        });
    });
}
